<template>
  <ul class="content-row" @click="handleRowClick">
    <template v-for="(col, idx2) of columns" :key="col.id || col.key">
      <li class="content-row__item" :class="[`content-row__item--${col.type}`]"
        :style="{ flex: col.width ? 'none' : '1', width: col.width, 'text-align': col.align }">

        <template v-if="col.type === 'label'">
          <div class="content-row__item__cell" :class="[{ 'content-row__item__cell--padding-left': idx2 === 0 }]">
            <template v-if="col.render">
              <component :is="col.render"
                v-bind="{ data, column: col, idx: idx1, listDataFn: detailContentData, idx2: idx2 }" />
            </template>
            <template v-else>
              <span class="content-row__item__text">{{ data[col.key] }}</span>
            </template>
          </div>
        </template>
        <template v-if="col.type === 'checkbox'">
          <div class="content-row__item__checkbox">
            <n-checkbox v-model:checked="isCheck" />
          </div>
        </template>
        <template v-if="col.type === 'action'">
          <detail-more />
        </template>
      </li>
    </template>
  </ul>
  <!-- v-if="renderData.moreDesc" -->
  <!-- v-if="renderData.moreDesc" -->
  <!-- {{data.track?.trackDescription}} -->
  <!-- {{renderData.expandDetail === 'list-detail' && renderData.detailDesc }} -->
  <!-- {{listFilter}} -->
  <div class="extra-info" :class="{ 'extra-info--is-search': renderData.isSearch }"
    v-if="renderData.expandDetail === 'list-detail' && renderData.detailDesc">

    <div class="desc"
      v-if="listFilter.includes('description') && (data.album?.albumDescription || data.track?.trackDescription || data?.description || data?.trackTitleDisplay)">
      <p class="desc__text">
        {{
          data.trackDescription || data.album?.albumDescription || data.track?.trackDescription || data?.description ||
          data?.trackTitleDisplay || ''
        }}
        <!-- Circular flow of warm energy. Emotional soulful wordless vocal with piano arpeggios and rhythmic backing vocals. -->
      </p>
    </div>
    <!-- <div class="desc" v-if="listFilter.includes('description')">
      <p class="desc__text">
        Circular flow of warm energy. Emotional soulful wordless vocal with piano arpeggios and rhythmic backing vocals.
      </p>
    </div> -->
    <div class="sound-wave" v-if="listFilter.includes('waves') && trackWave">
      <img class="sound-wave__img" :src="trackWaveSource(trackWave)" ref="soundWaveRef" @click="handlePosition" />
    </div>
    <div class="label-item" v-if="isShowTags">
      <tag-list :trackUid="data.trackUid || data.track?.trackUid || ''" />
    </div>
  </div>
  <div v-if="expandInnerMusicStatus">
    <music-detail :data="data" :key="uuid()" />
  </div>
</template>
<script>
import {
  defineComponent, ref, computed, inject, provide,
} from 'vue';
import {
  NCheckbox,
  // useMessage
} from 'naive-ui';
// import { useRoute } from 'vue-router';
import { v4 as uuid } from 'uuid';

import { useRoute } from 'vue-router';
// import { useI18n } from 'vue-i18n';
import MusicDetail from '@/components/MyMusic/MyMusicList/ListDetail/MusicDetail/index.vue';
import DetailMore from '@/components/Global/MusicPlayer/Fragment/DetailMore.vue';
import MusicProgress from '@/components/Global/MusicPlayer/MusicProgress.vue';
// import LabelItem from '@/components/Global/LabelItem.vue';
import { useSiteStore } from '@/store/site';
import { useMyMusicStore } from '@/store/myMusic';
import trackWaveSource from '@/utils/trackWaveSource';
import TagList from '@/components/Global/TagList.vue';
// import useMusicPlayer from '@/hooks/useMusicPlayer';
// import { useMusicPlayerStore } from '@/store/musicPlayer';
import { useNewMusicPlayerStore } from '@/store/newMusicPlayer';
// import useRequest from '@/hooks/useRequest';
// import { getAlbumAPI } from '@/api/getAlbums';
// import imageSource from '@/utils/imageSource';

export default defineComponent({
  name: 'ListDetailContentRow',
  components: {
    NCheckbox,
    MusicDetail,
    DetailMore,
    MusicProgress,
    // LabelItem,
    TagList,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    columns: {
      type: Object,
      default: () => ({}),
    },
    idx1: {
      type: Number,
    },
  },
  setup(props) {
    // const { handleFromExternalTrack, playMusic } = useMusicPlayer();
    const soundWaveRef = ref();
    const expandInnerMusicStatus = ref(false);
    const myMusicStore = useMyMusicStore();
    const siteStore = useSiteStore();
    const route = useRoute();
    // const message = useMessage();
    // const { t } = useI18n();
    // const musicPlayerStore = useMusicPlayerStore();
    const newMusicPlayerStore = useNewMusicPlayerStore();
    const renderData = computed(() => inject('listContentConfig', () => ({}))());
    const trackWave = computed(() => props.data?.trackWave || props.data?.track?.trackWave);
    const listFilter = computed(() => myMusicStore.listFilter);

    const isShowTags = computed(() => {
      if (route.name === 'my-music-playlists') {
        return null;
      }

      return listFilter.value.includes('tags') && (props.data.trackUid || props.data.track?.trackUid || null);
    });

    const handleInnerMusicExpand = () => {
      expandInnerMusicStatus.value = !expandInnerMusicStatus.value;
    };

    provide('expandInnerMusicStatus', () => expandInnerMusicStatus.value);
    provide('handleInnerMusicExpand', handleInnerMusicExpand);

    const detailContentData = inject('detailContentData');

    // const { request: reqAlbum, isLoading: reqAlbumLoading /* , response: albumData */ } = useRequest(getAlbumAPI);

    // const getAlbumDataToQueue = async (albumUids = []) => {
    //   // console.log('albumUids', albumUids);

    //   const albumReqList = albumUids.map((albumUid) => reqAlbum({ in: albumUid }));
    //   const albumResList = await Promise.all(albumReqList);
    //   const tracks = albumResList.reduce((acc, item) => {
    //     console.log('item', item);
    //     acc.push(
    //       ...item?.[1]?.getAlbum?.tracks.map((trackItems) => ({
    //         ...trackItems,
    //         labelCode: item?.publisherAndLabel?.[0]?.label?.labelCode || '',
    //         albumUid: item?.[1]?.getAlbum?.albumUid,
    //       })),
    //     );
    //     return acc;
    //   }, []);

    //   // console.log('tracks', tracks);

    //   const trackList = tracks;
    //   musicPlayerStore.handleAddToPlayQueue(
    //     trackList.map((item) => ({
    //       duration: item?.duration,
    //       id: `${item?.albumCode}-${item?.trackNumber}`,
    //       title: item?.trackTitleDisplay,
    //       trackUid: item?.trackUid,
    //       artworkInfo: item?.artworkInfo,
    //       albumInfo: {
    //         isMasterVersion: item?.isMasterVersion,
    //         albumCoverUrl: item?.artworkInfo,
    //         albumName: props.data?.albumTitleDisplay,
    //         albumUid: item?.albumUid,
    //         songName: item?.trackTitleDisplay,
    //         creator: item?.albumCode,
    //         duration: item?.duration,
    //         trackUid: item?.trackUid,
    //         trackWave: trackWaveSource(item?.trackWave),
    //         trackNumber: item?.trackNumber,
    //         uuid: uuid(),
    //         isrc: item.isrc || '',
    //         iswc: item.isrc || '',
    //         labelCode: item.labelCode || '',
    //       },
    //     })),
    //   );

    //   message.success(t('global.startPlaying'));
    //   // handlePlayFromQueue();

    //   playMusic(props.data?.albumInfo);
    // };

    const handlePosition = async (e) => {
      console.log('hi');
      // 點擊位置與左邊界的 x 距離
      const { offsetX } = e;
      // 進度條的長度
      const progressBarLength = soundWaveRef.value.clientWidth;
      // 點擊位置在進度條的百分比
      const clickPersentage = offsetX / progressBarLength;

      const duration = props.data.duration || props.data.track.duration;
      const trackUid = props.data.trackUid || props.data.track.trackUid;
      const time = duration * clickPersentage;

      newMusicPlayerStore.handleWavePlay(trackUid, time);
    };

    const handleRowClick = () => {
      // sm-pc 以上透過小箭頭展開
      if (siteStore.deviceType.includes('tablet')) return;

      if (route.name === 'my-music-playlists' && route.query.type === 'albums') {
        newMusicPlayerStore.handleAlbum(props.data.album.albumUid);
        return;
      }

      if (route.name === 'search' || (route.name === 'my-music-playlists' && route.query.type === 'tracks')) {
        // siteStore.toggleShowMobileMusicPlayer(true);
        const trackUid = props.data.trackUid || props.data.originUid || props.data?.track?.trackUid;
        console.log('trackUid', trackUid);
        newMusicPlayerStore.handleTrack(trackUid);

        // console.log(props.data.trackUid, props.data.originUid, props.data.originUid);
        // handleFromExternalTrack(props.data.trackUid || props.data.originUid);
      }
    };

    return {
      isCheck: ref(false),
      listFilter,
      renderData,
      expandInnerMusicStatus,
      isShowTags,
      // tagList,
      uuid,
      trackWave,
      trackWaveSource,
      detailContentData,
      handleRowClick,
      handlePosition,
      soundWaveRef,
      // reqAlbumLoading,
    };
  },
});
</script>
<style lang="scss" scoped>
.content-row {
  width: 100%;
  height: 56px;
  @include flex();
  @include padding(0 16px);

  &__item {
    @include flex();

    &__text {
      @include font-style($c-assist6, 14, normal, 0, 26px);
    }

    &__padding-left {
      padding-left: 20px;
      width: 100%;
    }

    &__cell {
      width: 100%;

      &--padding-left {
        margin-left: 0px;
        width: 100%;
      }
    }

    &__checkbox {
      width: 100%;
      @include flex(center);
    }
  }
}

.extra-info {
  @include padding(0 120px 0px 65px);

  &--is-search {
    /* @include padding(0 60px 0px 105px); */
    @include padding(0 60px 0px 57px);

    // .desc__text {
    //   padding: 0;
    // }

    // .sound-wave {
    //   padding: 0;
    // }
  }
}

.desc {
  // margin-top: 12px;
  padding-bottom: 16px;

  &__text {
    @include font-style($c-assist4, 14, normal, 0.8px, 18px);
  }
}

.sound-wave {
  @include padding(0 0px 16px);
  @include optimizeImage();

  &__img {
    width: 100%;
    height: 50px;
  }
}

.label-items {
  @include padding(0 0px 16px);
}

@media screen and (min-width: $sm-pc) {
  .content-row {
    height: 80px;
    @include padding(0 0px);

    &__item {
      &__cell {
        &--padding-left {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
